import React from "react"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"

const Rotate = ({ useTheme = true }) => {
    const { adventure_mode } = useSelector((store) => store.user)
    const themeColor = adventure_mode === "sportsman" ? "var(--color-sportsman-brand)" : "var(--color-sportswoman-brand)"

    // Use theme color when useTheme is true, otherwise use normal gray color
    const primaryColor = useTheme ? themeColor : "var(--color-text-secondary-light)"

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_37841_38773)">
                <path d="M15.334 2.66675V6.66675H11.334" stroke={primaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M13.6593 9.99993C13.2259 11.2265 12.4056 12.2791 11.322 12.9989C10.2384 13.7188 8.95024 14.067 7.65155 13.991C6.35286 13.915 5.11404 13.419 4.12177 12.5777C3.12951 11.7364 2.43755 10.5954 2.15018 9.32663C1.86281 8.05786 1.99559 6.73005 2.52851 5.54331C3.06143 4.35656 3.96563 3.37517 5.10484 2.74702C6.24405 2.11887 7.55656 1.87799 8.84457 2.06069C10.1326 2.24339 11.3263 2.83975 12.2459 3.75993L15.3326 6.66659" stroke={primaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_37841_38773">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

Rotate.propTypes = {
    useTheme: PropTypes.bool
}

export { Rotate };



